export enum ReinsuranceType {
  'FACOLTATIVO' = 'F',
  'TRATTATO' = 'T',
  'SPECIALE' = 'S',
  'FACILITY' = 'Y',
}